import React from 'react';
import styled from '@emotion/native';
import useBreakpoint from '@/shared/hooks/useBreakpoint';
import EditProfileForm from '@/components/editProfileForm/EditProfileForm';
import { useGetUser } from '@/shared/hooks/useGetUser';
import ScrollableView from '@/shared/components/ScrollableView';
import { sand, white } from '@/shared/styles/colors';

const Profile = () => {
  const { isDesktop } = useBreakpoint();
  const { user } = useGetUser();

  return (
    <ScrollableView
      contentContainerStyle={{
        alignItems: 'center',
      }}
      scrollEnabled
    >
      <Container isDesktop={isDesktop}>
        <ContentContainer>
          {user && <EditProfileForm user={user} />}
        </ContentContainer>
      </Container>
    </ScrollableView>
  );
};

export default Profile;

const Container = styled.View<{ isDesktop: boolean }>(({ isDesktop }) => ({
  marginHorizontal: isDesktop ? 48 : 0,
  paddingTop: isDesktop ? 0 : 40,
  backgroundColor: isDesktop ? white : sand,
  display: 'flex',
  alignSelf: 'stretch',
  flex: 1,
}));

const ContentContainer = styled.View({
  alignSelf: 'stretch',
  height: '100%',
});
